<div class="row mt-3 mb-3" *ngIf="edicao">
  <div class="col-12">
    <button (click)="adicionar()" class="btn btn-sm btn-primary">
      <i class="fa fa-plus"></i> Incluir proponente
    </button>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <table class="table table-sm table-eddy">
      <thead>
        <tr>
          <th scope="col" style="width: 50px" class="text-center">Ordem</th>
          <th scope="col">Razão Social / CNPJ</th>
          <th scope="col">Telefone / E-mail</th>
          <th scope="col">Representante</th>
          <th scope="col" style="width: 60px" class="text-center">EPP/ME</th>
          <th scope="col" style="width: 95px" class="text-center">Situação</th>
          <th scope="col" style="width: 90px" *ngIf="edicao"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of entidade.proponentes; let idx = index">
          <td class="text-center">
            {{item.ordem}}
          </td>
          <td>
            <span class="d-block">{{item.favorecido.nome}}</span>
            <span class="text-muted">{{item.favorecido.cpf_cnpj | CPF}}</span>
          </td>
          <td>
            <span class="d-block">{{item.favorecido.telefone | TELEFONE}}</span>
            <span class="text-primary">{{item.favorecido.email}}</span>
          </td>
          <td>
            {{item.favorecido.responsavel}}
          </td>
          <td class="text-center">
            <span *ngIf="item.epp_me" class="badge badge-success">Sim</span>
            <span *ngIf="!item.epp_me" class="badge badge-secondary">Não</span>
          </td>
          <td class="text-center">
            <span [class]="'badge badge-' + (item.situacao === 'HABILITADO' ? 'success' : 'danger')"
              [title]="funcaoService.abreviarStr(item.motivo, 50, true)">{{funcaoService.capitalizeFirstLetter(item.situacao)}}</span>
          </td>
          <td class="text-right" *ngIf="edicao">
            <button (click)="itemAtual = item" data-toggle="modal" data-target="#dialogFavorecidoCadastro"
              class="btn btn-sm btn-outline-primary mr-2">
              <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
            </button>
            <button (click)="remover(item, idx)" class="btn btn-sm btn-outline-primary">
              <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<lib-favorecido-cadastro-dlg *ngIf="edicao" [login]="login" [origem_proponente]="true" [proponente]="itemAtual"
  (callbackProponente)="salvar($event)">
</lib-favorecido-cadastro-dlg>